<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="500"
    >
      <v-card :loading="loading">
        <v-card-title class="text-h5">
          Activate Member Registration
        </v-card-title>
        <v-card-text class="pt-4">
          <v-autocomplete
            v-model="entry_type"
            :items="['ECONOMY','RESELLER']"
            dense
            auto-select-first
            label="ENTRY TYPE"
            :append-icon="icon.entry"
            :class="formErrorFields.entry_typeErrorMessage.length > 0 ? 'mb-3' : ''"
            :error-messages="formErrorFields.entry_typeErrorMessage"
            @change="selected"
          >
          </v-autocomplete>
          <v-autocomplete
            v-model="entry_status"
            :items="['CD', 'FREE']"
            dense
            auto-select-first
            label="ENTRY STATUS"
            :append-icon="icon.entry"
            :class="formErrorFields.entry_statusErrorMessage.length > 0 ? 'mb-3' : 'mt-4'"
            :error-messages="formErrorFields.entry_statusErrorMessage"
            @change="selected"
          >
          </v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="close"
          >
            Cancel
          </v-btn>
          <v-btn
            color="success"
            text
            @click="submit"
          >
            Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <snackbar
      v-if="responseMessage.length > 0"
      :show="responseMessage.length > 0"
      :text="responseMessage"
      :color="responseMessageStatus"
      @close="responseMessage=''"
    />
  </div>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import { mdiPackage } from '@mdi/js'
import formError from '@/composables/formErrorHandler/formError'
import crud from '@/composables/crud'
import snackbar from '@/components/SnackBar.vue'

export default {
  components: {
    snackbar,
  },

  props: {
    showDialog: Boolean,
    data: null,
    errorMessage: [],
  },

  setup(props, { emit }) {
    const icon = { entry: mdiPackage }
    const dialog = ref(props.showDialog)
    const loading = ref(false)
    const entry_type = ref('')
    const entry_status = ref('')
    const formErrorFields = ref({
      entry_typeErrorMessage: '',
      entry_statusErrorMessage: '',
    })
    const { store, responseMessageStatus, responseMessage } = crud()

    watch(() => props.showDialog, val => {
      console.log(val)
      dialog.value = val
    })

    watch(() => props.errorMessage, val => {
      formErrorFields.value.entry_typeErrorMessage = val
      formErrorFields.value.entry_statusErrorMessage = val
    })

    const selected = val => {
      formError().remove('entry_type', formErrorFields.value)
      formError().remove('entry_status', formErrorFields.value)
    }

    const close = () => {
      dialog.value = false
      emit('closeDialog')
    }

    const submit = async () => {
      if(entry_type.value === '') {
        formErrorFields.value.entry_typeErrorMessage = "Entry type is required"
      } else if(entry_status.value === '') {
        formErrorFields.value.entry_typeErrorMessage = "Entry status is required"
      } else {
        await store(`${process.env.VUE_APP_URI}/api/admin/members/activate`, loading, { 
          memberId: props.data, 
          entryType: entry_type.value,
          entryStatus: entry_status.value 
        }, formErrorFields)

        if (responseMessageStatus.value === 'success') {
          emit('updateTable')
          setTimeout(function() {
            emit('closeDialog')
          }, 2000)
        }
      }
    }

    return {
      dialog,
      icon,
      entry_type,
      entry_status,
      formErrorFields,
      formError,
      selected,
      submit,
      close,
      responseMessage,
      responseMessageStatus,
      loading,
    }
  },
}
</script>
